export default __webpack_public_path__ + "./images/tz.d82f3c2a.png";